import { get } from 'lodash';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { LIST_BUDGET_NEWS } from '../../apiConst';
import SelectDropdown from '../../Common/SelectDropdown';
import { taskStatusOptions } from '../../utils';
import { postRequest, putRequest } from '../interceptor/interceptor';
import FullScreenLoader from '../Loader/FullScreenLoader';
import { FaListUl, FaThLarge, FaTasks } from 'react-icons/fa';
import { VscTasklist } from 'react-icons/vsc';

import { Button } from '@mui/material';
import { IoMdAdd, IoMdSend } from 'react-icons/io';
import { resetClipboardStubOnView } from '@testing-library/user-event/dist/cjs/utils/index.js';
import VideosList from './videosList';

export default function Videos() {
  const [isLoading, setIsLoading] = useState(false);
  const [isDisplay, setIsDisplay] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(rowsPerPage);
  const [tableRowsData, setTableRowsData] = useState([]);
  const { role } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    fetchListData();
  }, []);
  const fetchListData = (pg = 1, size = 10, search = '', searchKey = null) => {
    setIsLoading(true);

    let payload = {
      filter: {
        type: 'video',
      },
      sortOrder: -1,
      page: pg,
      pageSize: size,
      module: 'news',
    };

    const { searchField } = getValues();
    const key = searchKey ? searchKey : searchField;
    if (key && search) {
      payload.filter[key] = search;
    }
    postRequest(LIST_BUDGET_NEWS, payload)
      .then((res) => {
        console.log('res', res);
        const { result, totalCount } = res.data.data;
        setTableRowsData(result || []);
        setTotalCount(totalCount || result.length);
        setIsLoading(false);
        setIsDisplay(true);
      })
      .catch(() => {
        setIsLoading(false);
        setTableRowsData([]);
        setTotalCount(0);
      });
  };

  const onNewTask = () => {
    navigate('/add-video', {
      state: {
        data: {},
      },
    });
  };

  const onEdit = (task) => {
    navigate('/add-video', {
      state: {
        data: {
          task: {
            ...task,
          },
        },
        isEdit: true,
      },
    });
  };

  return (
    <>
      {isLoading && <FullScreenLoader />}

      <form>
        <div className="flex flex-col gap-2 lg:flex-row lg:justify-end">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-48 lg:mr-3">
              {['Super-Admin', 'Admin', 'Web-Portal-Data-Entry'].includes(
                role
              ) && (
                <Button
                  className="w-full lg:w-48 lg:mr-3 bg-blueBg hover:bg-blueBg"
                  type="button"
                  onClick={() => onNewTask()}
                  variant="contained"
                  // color="info"
                  startIcon={<IoMdAdd />}
                >
                  Add Video
                </Button>
              )}
            </div>
          </div>
        </div>
      </form>
      <VideosList
        tableRowsData={tableRowsData}
        getListData={fetchListData}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalCount={totalCount}
        page={page}
        setPage={setPage}
        onEdit={onEdit}
        // onView={onView}
        // onStepperForm={onStepperForm}
        register={register}
        errors={errors}
      />
    </>
  );
}
